export default __webpack_public_path__ + "static/media/simplicity.a7ccdd0a.svg";